import { useFormikContext } from "formik"
import { ISolution } from "../models/Solution"
import { RawNumberMuiFieldAdvanced } from "./muiFields/StyledNumberMuiField"
import { Separator } from "./Separator"
import { StyledCheckBox } from "./Checkbox"
import { StyledMuiFieldLabel } from "./muiFields/MuiFIeldLabel"
import { ProductType } from "../models/Product"
import { ReactElement, useState } from "react"

export function GlassWH(props: { productType: ProductType }): ReactElement {
  const { values, setFieldValue } = useFormikContext<ISolution>()
  const [offset, setOffset] = useState<[boolean, boolean, boolean]>([
    !(
      values.glass.centralOffsetX[0] === 0 &&
      values.glass.centralOffsetY[0] === 0
    ),
    !(
      values.glass.centralOffsetX[1] === 0 &&
      values.glass.centralOffsetY[1] === 0
    ),
    !(
      values.glass.centralOffsetX[2] === 0 &&
      values.glass.centralOffsetY[2] === 0
    ),
  ])
  const independent = values.glass.independentWH

  if (props.productType === ProductType.FortouchO)
    return (
      <>
        {independent && (
          <StyledMuiFieldLabel label={"Front glass"} paired={true} />
        )}
        <RawNumberMuiFieldAdvanced
          {...sx_(
            values.glass.width[0],
            "glass.width[0]",
            setFieldValue,
            "Width (mm)"
          )}
        />
        <RawNumberMuiFieldAdvanced
          {...sx_(
            values.glass.height[0],
            "glass.height[0]",
            setFieldValue,
            "Height (mm)"
          )}
        />

        {independent && (
          <>
            {offset[0] && (
              <>
                <RawNumberMuiFieldAdvanced
                  {...sx_(
                    values.glass.centralOffsetX[0],
                    "glass.centralOffsetX[0]",
                    setFieldValue,
                    "X offset",
                    true
                  )}
                />
                <RawNumberMuiFieldAdvanced
                  {...sx_(
                    values.glass.centralOffsetY[0],
                    "glass.centralOffsetY[0]",
                    setFieldValue,
                    "Y offset",
                    true
                  )}
                />
              </>
            )}
            <StyledCheckBox
              name="Front glass offset"
              checked={offset[0]}
              onChange={() => {
                setOffset([!offset[0], offset[1], offset[2]])
              }}
              paired
            />

            <StyledMuiFieldLabel label={"Middle glass"} paired={true} />
            <RawNumberMuiFieldAdvanced
              {...sx_(
                values.glass.width[1],
                "glass.width[1]",
                setFieldValue,
                "Width (mm)"
              )}
            />
            <RawNumberMuiFieldAdvanced
              {...sx_(
                values.glass.height[1],
                "glass.height[1]",
                setFieldValue,
                "Height (mm)"
              )}
            />
            {offset[1] && (
              <>
                <RawNumberMuiFieldAdvanced
                  {...sx_(
                    values.glass.centralOffsetX[1],
                    "glass.centralOffsetX[1]",
                    setFieldValue,
                    "X offset",
                    true
                  )}
                />
                <RawNumberMuiFieldAdvanced
                  {...sx_(
                    values.glass.centralOffsetY[1],
                    "glass.centralOffsetY[1]",
                    setFieldValue,
                    "Y offset",
                    true
                  )}
                />
              </>
            )}
            <StyledCheckBox
              name="Middle glass offset"
              checked={offset[1]}
              onChange={() => {
                setOffset([offset[0], !offset[1], offset[2]])
              }}
              paired
            />

            <StyledMuiFieldLabel label={"Rear glass"} paired={true} />
            <RawNumberMuiFieldAdvanced
              {...sx_(
                values.glass.width[2],
                "glass.width[2]",
                setFieldValue,
                "Width (mm)"
              )}
            />
            <RawNumberMuiFieldAdvanced
              {...sx_(
                values.glass.height[2],
                "glass.height[2]",
                setFieldValue,
                "Height (mm)"
              )}
            />
            {offset[2] && (
              <>
                <RawNumberMuiFieldAdvanced
                  {...sx_(
                    values.glass.centralOffsetX[2],
                    "glass.centralOffsetX[2]",
                    setFieldValue,
                    "X offset",
                    true
                  )}
                />
                <RawNumberMuiFieldAdvanced
                  {...sx_(
                    values.glass.centralOffsetY[2],
                    "glass.centralOffsetY[2]",
                    setFieldValue,
                    "Y offset",
                    true
                  )}
                />
              </>
            )}
            <StyledCheckBox
              name="Rear glass offset"
              checked={offset[2]}
              onChange={() => {
                setOffset([offset[0], offset[1], !offset[2]])
              }}
              paired
            />
          </>
        )}
        <StyledCheckBox
          name="Independent layers"
          checked={independent}
          onChange={() => setFieldValue("glass.independentWH", !independent)}
        />
        <Separator />
      </>
    )

  return (
    <>
      <RawNumberMuiFieldAdvanced
        {...sx_(
          values.glass.width[0],
          "glass.width[0]",
          setFieldValue,
          "Width (mm)"
        )}
      />
      <RawNumberMuiFieldAdvanced
        {...sx_(
          values.glass.height[0],
          "glass.height[0]",
          setFieldValue,
          "Height (mm)"
        )}
      />
      <Separator />
    </>
  )
}

const sx_ = (
  val: number,
  name: string,
  setFieldValue: any,
  label: string,
  paired?: boolean
) => {
  return {
    onChange: (e: any) => setFieldValue(name, Number(e.target.value)),
    name: name,
    integer: false,
    defaultValue: val,
    label: label,
    step: 10,
    paired: paired === true,
  }
}
